<template>
  <div id="app">
    <router-view />
  </div>
</template>
<script>
export default {
  name: "App",
  beforeCreate: function() {
    if (localStorage.token !== undefined) {
      this.$store.commit("set_token", localStorage.token);
    }
    if (localStorage.userid !== undefined) {
      this.$store.commit("set_userid", localStorage.userid);
    }
    if (localStorage.user !== undefined) {
      this.$store.commit("set_user", localStorage.user);
    }
    if (localStorage.lastime !== undefined) {
      this.$store.commit("set_lastime", localStorage.lastime);
    }
  }
};
</script>

<style>
.el-date-range-picker {
  width: 490px !important;
}
.el-upload-dragger {
  width: 260px !important;
}
.el-table .cell {
  white-space: nowrap;
}
.success-row {
  background: #f0f9eb !important;
}
.el-date-range-picker .el-picker-panel__body {
  min-width: 490px;
}
</style>



// WEBPACK FOOTER //
// src/App.vue